/*
  Flavour splashes: sized and placed relative to the bag itself (not the column),
  so they keep the same proportions on desktop, tablet and mobile. Each splash
  fades out just above the bottom of the bag, so it only shows out the sides.
*/
if (!window.sgSplashClip) {
  (() => {
    const FEATURE = { size: 126, offset: -17 };
    const cache = new WeakMap();
    const bagFraction = (img) => {
      const hit = cache.get(img);
      if (hit && hit.src === img.currentSrc) return hit.f;
      const w = 80;
      const h = Math.max(1, Math.round((w * img.naturalHeight) / img.naturalWidth));
      const c = document.createElement('canvas');
      c.width = w;
      c.height = h;
      const ctx = c.getContext('2d', { willReadFrequently: true });
      let f = 1;
      try {
        ctx.drawImage(img, 0, 0, w, h);
        const d = ctx.getImageData(0, 0, w, h).data;
        scan: for (let y = h - 1; y >= 0; y--) {
          for (let x = 0; x < w; x++) {
            if (d[(y * w + x) * 4 + 3] > 40) { f = (y + 1) / h; break scan; }
          }
        }
      } catch (e) {
        f = 1;
      }
      cache.set(img, { src: img.currentSrc, f });
      return f;
    };
    /* Visible picture box of a contained image, given its layout box */
    const contentBox = (img, left, top, width, height) => {
      const s = Math.min(width / img.naturalWidth, height / img.naturalHeight);
      const w = img.naturalWidth * s;
      const h = img.naturalHeight * s;
      const t = top + (height - h) / 2;
      return { cx: left + width / 2, top: t, bottom: t + h, w, h, bag: t + bagFraction(img) * h };
    };
    /* Geometry for a splash, in the container's coordinates (y down) */
    const place = (box, size, offset) => {
      const width = (box.w * size) / 100;
      const bottom = box.bottom - (box.h * offset) / 100;
      const end = Math.max(0, bottom - box.bag) + box.h * 0.03;
      return { width, left: box.cx - width / 2, bottom, end, start: end + box.h * 0.22 };
    };
    const ready = (img) => img && img.complete && img.naturalWidth;
    const run = () => {
      document.querySelectorAll('.sg-hero__slide').forEach((slide) => {
        const splash = slide.querySelector('.sg-hero__splash');
        const img = slide.querySelector('.sg-hero__img');
        const media = slide.querySelector('.sg-hero__media');
        if (!splash || !ready(img) || !img.offsetWidth) return;
        /* offset* ignores the slide-in transform, so inactive slides measure correctly */
        const box = contentBox(img, img.offsetLeft, img.offsetTop, img.offsetWidth, img.offsetHeight);
        const p = place(box, parseFloat(splash.dataset.size) || 118, parseFloat(splash.dataset.offset) || 0);
        const mask = 'linear-gradient(to top, transparent ' + p.end + 'px, #000 ' + p.start + 'px)';
        splash.style.width = p.width + 'px';
        splash.style.left = p.left + p.width / 2 + 'px';
        splash.style.bottom = media.clientHeight - p.bottom + 'px';
        splash.style.webkitMaskImage = mask;
        splash.style.maskImage = mask;
        splash.classList.add('is-placed');
      });
      document
        .querySelectorAll("[id$='__whey_feature'] .media-block, [id$='__hydration_range'] .media-block")
        .forEach((block) => {
          const img = block.querySelector('img');
          if (!ready(img)) return;
          const br = block.getBoundingClientRect();
          const r = img.getBoundingClientRect();
          if (!r.width) return;
          const box = contentBox(img, r.left - br.left, r.top - br.top, r.width, r.height);
          const p = place(box, FEATURE.size, FEATURE.offset);
          block.style.setProperty('--sg-sp-w', p.width + 'px');
          block.style.setProperty('--sg-sp-l', p.left + 'px');
          block.style.setProperty('--sg-sp-b', br.height - p.bottom + 'px');
          block.style.setProperty('--sg-fade-end', p.end + 'px');
          block.style.setProperty('--sg-fade-start', p.start + 'px');
          block.classList.add('sg-splash-placed');
        });
    };
    window.sgSplashClip = run;
    let t;
    const later = () => { clearTimeout(t); t = setTimeout(run, 120); };
    window.addEventListener('load', run);
    window.addEventListener('resize', later);
    document.addEventListener('shopify:section:load', later);
    document.addEventListener('load', (e) => { if (e.target.tagName === 'IMG') later(); }, true);
    if (document.readyState !== 'loading') later();
    else document.addEventListener('DOMContentLoaded', later);
  })();
}
